import DataUtils from "../../../utils/dataUtils";
import { EmptyComponent } from "../../common/EmptyComponent";
import Loadable from "react-loadable";

const LoyaltyIndication = Loadable({
  loader: () =>
    import(/* webpackChunkName: "container/loyalty" */ "./LoyaltyIndication"),
  loading: EmptyComponent
});

const isLoyaltyEnabled =
  DataUtils.getDataStoreValue("LoyaltyIndicationEnabled") === true;

let Loyalty = isLoyaltyEnabled ? LoyaltyIndication : EmptyComponent;

export default Loyalty;
